module.exports = __webpack_public_path__ + "static/media/cocinafacil.dd1dc339.svg";